<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <div class="row pad-top-30">
      <p
        class="column twelve"
        dsContent
        [contentPath]="'contactAdjuster.contactAdjusterConfirmationNextSteps'"
      ></p>
    </div>
    <div class="row pad-bottom-30 pad-top-10">
      <div class="column twelve md-two"><b>Comment:</b></div>
      <div class="column twelve md-ten">{{ contactInfo.comment }}</div>
    </div>
    <ds-confirmation-link-area>
      <a class="font-weight-semibold" href="javascript:void(0);" (click)="backToClaims()"
        >Back To Claims</a
      >
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
